//deps
import React, { memo, useMemo } from "react";
import { ElementObserver } from "../ElementObserver";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";

//types
import { CancellationPolicyWidgetProps } from "./types";
import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types";

//components
import { CancellationDisclaimerContainer, StyledText } from "./styles";
import { CANCELLATION_DISCLAIMER_CONTAINER } from "@swiggy-private/cart-test-ids";

const CancellationPolicyWidget: React.FC<CancellationPolicyWidgetProps> = ({ cancellationDisclaimerData, onViewEnter }) => {
    const canRenderCancellationDisclaimer = useMemo(
        () => !isEmpty(cancellationDisclaimerData),
        [cancellationDisclaimerData],
    );

    //if the disclaimer data is not present return null
    if (!canRenderCancellationDisclaimer || !cancellationDisclaimerData) {
        return null;
    }

    const { title, description } = cancellationDisclaimerData;

    return (
        <ElementObserver onViewEnter={onViewEnter}>
            <CancellationDisclaimerContainer data-testid={CANCELLATION_DISCLAIMER_CONTAINER}>
                <StyledText
                    asElement="h2"
                    variant={(title?.variant as keyof ITypography) || "V2.body3.neutral.bold"}
                    color={(title?.color as keyof IColors) || "text_Low_Emphasis"}
                >
                    {title?.text || ""}
                </StyledText>
                <StyledText
                    variant={(description?.variant as keyof ITypography) || "V2.body3.neutral.regular"}
                    color={(description?.color as keyof IColors) || "text_Low_Emphasis"}
                >
                    {description?.text || ""}
                </StyledText>
            </CancellationDisclaimerContainer>
        </ElementObserver>
    );
};

export default memo(CancellationPolicyWidget);
